import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
  FetchPolicy,
} from '@bingads-webui-react/overreact';
import type { RequestFactoryContext } from '@bingads-webui-react/overreact';

import { schema } from '../../../environment/schema';
import { getDefaultOptions } from '../../../request-contract-helper/index';
import type {
  Account,
  AccountsVariables,
  EntityCollectionResponse,
} from '../../../types';

function ccUrlFactory(params: RequestFactoryContext<AccountsVariables, null>) {
  const { variables } = params;

  const {
    locator,
    top,
    skip,
    predicates,
    name,
  } = variables;

  const { descriptor } = locator;
  const { uid, cid } = descriptor;

  let search: Record<string, string | number | undefined> = {
    uid,
    cid,
    customerId: cid,
  };
  if (_.isNumber(top)) {
    search = {
      ...search,

      top,
    };
  }
  if (_.isNumber(skip)) {
    search = {
      ...search,

      skip,
    };
  }
  if (predicates) {
    search = {
      ...search,

      predicates: JSON.stringify(predicates),
    };
  }
  if (name) {
    search = {
      ...search,

      name,
    };
  }

  const searchString = _.isEmpty(search) ? '' : `?${queryString.stringify(search)}`;

  return `cc/API/Account${searchString}`;
}

function ccOptionsFactory() {
  return getDefaultOptions();
}

export const fetchRequestContract = createRequestContract<AccountsVariables, null>({
  schema,
  dataPath: 'user:customer:account',
  verb: requestVerbs.GET,
  fetchPolicy: FetchPolicy.StoreOrNetwork,
  uriFactoryFn: ccUrlFactory,

  headerFactoryFn: ccOptionsFactory,

  parentKeySelector: variables => variables.locator.descriptor.cid,
});

export const fetchResponseContract = createResponseContract<
  AccountsVariables,
  null,
  Account,
  EntityCollectionResponse<Account>,
  Account[]
>({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,

  keySelector: account => account.id,

  processorFn: response => response.value,
});
